var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-white shadow-md hover:shadow-xl rounded-xl transition-all delay-100 duration-75 min-h-80",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-16 bg-gray-100 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
        },
        [_vm._t("header")],
        2
      ),
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "mx-8 p-5 mt-12 border-2 border-t-0 rounded-2xl my-4 w-11/12 flex gap-6 justify-between",
          },
          [_vm._t("default")],
          2
        ),
        _c("div", { staticClass: "flex justify-center h-5" }, [
          _c(
            "div",
            { staticClass: "w-10/12 flex gap-3 xxl:gap-8 justify-between" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "-mt-6 rounded-2xl flex gap-6 w-1/3 xxl:ml-0 ml-5",
                },
                [_vm._t("avatarpointers")],
                2
              ),
              _c(
                "div",
                {
                  staticClass:
                    "-mt-6 rounded-2xl flex gap-6 w-1/3 xxl:ml-0 ml-5",
                },
                [_vm._t("avatarpointers2")],
                2
              ),
              _c(
                "div",
                {
                  staticClass:
                    "-mt-6 rounded-2xl flex gap-6 w-1/3 xxl:ml-0 ml-5",
                },
                [_vm._t("avatarpointers3")],
                2
              ),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass:
            "h-16 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
        },
        [_vm._t("recruiting")],
        2
      ),
      _vm.$slots.recruitingcards
        ? _c(
            "div",
            {
              staticClass:
                "mx-8 p-5 border-2 border-t-0 rounded-2xl my-4 w-11/12 flex gap-6",
            },
            [_vm._t("recruitingcards")],
            2
          )
        : _vm._e(),
      _vm.$slots.mycontractors
        ? _c(
            "div",
            {
              staticClass:
                "h-0 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
            },
            [_vm._t("mycontractors")],
            2
          )
        : _vm._e(),
      _vm.$slots.mycontractorscards
        ? _c(
            "div",
            {
              staticClass:
                "mx-8 p-5 border-2 border-t-0 rounded-2xl my-4 w-11/12 flex gap-6",
            },
            [_vm._t("mycontractorscards")],
            2
          )
        : _vm._e(),
      _vm.$slots.mycontractorsavatarpointers
        ? _c("div", [_vm._t("mycontractorsavatarpointers")], 2)
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }